import { FC } from 'react'

import styled from 'styled-components'

import { ScheduleSettingsPageSkeleton } from 'src/Pages/Artist/ScheduleSettingsPageSkeleton'
import { ScheduleSettingsHeader } from 'src/Components/ScheduleSettingsHeader'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'
import {
  getIsManualMatchingCampaign,
  getScheduleMatchingType,
} from 'src/Hooks/Experiments/useManualMatchingExperiment'

import { SpotifyScheduleModals } from './SpotifyScheduleModals'
import { SpotifyTrackParameters } from './SpotifyTrackParametrs'
import { SpotifyCampaignSteps } from './SpotifyCampaignSteps'
import { ManualMatchingCuratorsList } from './ManualMatchingCuratorsList'
import { useSpotifyScheduleStartDate } from './useSpotifyScheduleStartDate'
import { useAreMatchedCuratorsBelowMinBudget } from './useAreMatchedCuratorsBelowMinBudget'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  @media screen and (min-width: 768px) {
    align-items: flex-start;
    flex-direction: row;
    align-self: stretch;
  }
`

export const SpotifyScheduleSettingsPage: FC = () => {
  const { campaignDetails, isLoading, matchingType, isPreRelease } =
    useSpotifyCampaignStatus()

  const isManualMatching =
    !isPreRelease && getIsManualMatchingCampaign(matchingType)

  const { startDate, todayEnable, onChangeDate } = useSpotifyScheduleStartDate()

  const areMatchedCuratorsBelowMinBudget =
    useAreMatchedCuratorsBelowMinBudget(isManualMatching)

  if (isLoading || !campaignDetails) {
    return <ScheduleSettingsPageSkeleton />
  }

  return (
    <>
      <SpotifyScheduleModals />
      <Container>
        <ScheduleSettingsHeader
          artistName={campaignDetails.track.author}
          trackCover={campaignDetails.track.cover}
          trackName={campaignDetails.track.title}
          platform={CampaignPlatformTypeEnum.SPOTIFY}
          startDate={startDate}
          todayEnable={todayEnable}
          onChangeDate={onChangeDate}
          isEditable={true}
          matchingType={getScheduleMatchingType(matchingType)}
          isPreRelease={isPreRelease}
        />
        <Wrapper>
          <SpotifyTrackParameters />
          {!isManualMatching && <SpotifyCampaignSteps />}
        </Wrapper>
        {isManualMatching && !areMatchedCuratorsBelowMinBudget && (
          <ManualMatchingCuratorsList />
        )}
      </Container>
    </>
  )
}
